import React from "react";
import { Feed, Icon } from "semantic-ui-react";
import { calculateDateDifference, printDaysToGo } from "../../Helpers";
import "../../styles/list.scss";

const BCDashboardEvents = ({ ...props }) => {
  return (
    <Feed className="dashboard-feed">
      <Feed.Event>
        <Feed.Content>
          {props.data && props.data.map((item, i) => {
            return (
              <Feed.Summary key={"dashboard-event-" + i} className={item.type === "amendment" ? "dashboard-feed-summary dashboard-feed-yellow" : "dashboard-feed-summary dashboard-feed-red"}>
                {item.date}: {item.event}
                <Feed.Date>{printDaysToGo(calculateDateDifference(item.date))}</Feed.Date>
                <div className="dashboard-feed-review">
                  <span>{item.type === "amendment" ? "SUBMIT AMENDMENT" : "REVIEW"}</span>
                  <Icon className="dashboard-feed-icon" name='angle right' size="large" />
                </div>
              </Feed.Summary>
            );
          })}
        </Feed.Content>
      </Feed.Event>
    </Feed>
  );
};

export default BCDashboardEvents;